import LiveAssistScriptEmbed from './LiveAssistScriptEmbed.component';
export default LiveAssistScriptEmbed;